import { MenuItemComponentType } from "../../constants";
import { KambiAllSportsMenuItem } from "./KambiAllSportsMenuItem";
import { ExpandableSportCategoryMenuItem } from "./ExpandableSportCategoryMenuItem";
import { SportCategoryMenuItem } from "./SportCategoryMenuItem";
import React from "react";
import PropTypes from "prop-types";
import { ExpandableSportCategoryMenuItemMobile } from "../MenuV2/ExpandableSportCategoryMenuItemMobile";
import { KambiMobileExpandMenuItem } from "./KambiMobileExpandMenuItem";

export const MenuItemFactory = ({ componentType, componentProps }) => {
  switch (componentType) {
    case MenuItemComponentType.KambiAllSportsMenuItem: {
      return <KambiAllSportsMenuItem {...componentProps} />;
    }
    case MenuItemComponentType.SportCategoryMenuItem: {
      return <SportCategoryMenuItem {...componentProps} />;
    }
    case MenuItemComponentType.ExpandableSportCategoryMenuItem: {
      return <ExpandableSportCategoryMenuItem {...componentProps} />;
    }
    case MenuItemComponentType.ExpandableSportCategoryMenuItemMobile: {
      return <ExpandableSportCategoryMenuItemMobile {...componentProps} />;
    }
    case MenuItemComponentType.KambiMobileExpandMenuItem: {
      return <KambiMobileExpandMenuItem {...componentProps} />;
    }
    default: {
      return null;
    }
  }
};

MenuItemFactory.propTypes = {
  componentType: PropTypes.string,
  componentProps: PropTypes.object
};
